import React from 'react';
import './FootballFieldPlayers.css'
function FieldPlayers(props) {

    const { strPlayer, strTeamBadge } = props;

    return (
        <div className='playerCardField'>
            <img className='teamBagdeField' src={strTeamBadge} alt={`${strPlayer} team bagde`} />
            <h1 className='playerNameField'>{strPlayer}</h1>
        </div>
    )
}

export default FieldPlayers;
